import { render } from "./SdShowCase-Nav.vue?vue&type=template&id=36785bb6"
import script from "./SdShowCase-Nav.vue?vue&type=script&lang=js"
export * from "./SdShowCase-Nav.vue?vue&type=script&lang=js"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__